// extracted by mini-css-extract-plugin
export default {"link":"TemplateLink_link__tghqE","template":"TemplateLink_template__lUZAu","textButton":"TemplateLink_textButton__twpQi"};